// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import { observable } from 'mobx';

export class MessageStore {
    @observable type: string = '';
    @observable message: string = '';

    setMessage(type: string, message: string, time: number = 4000): void {
        this.type = type;
        this.message = message;
        const me = this;
        
        setTimeout(() => {
            me.type = '';
            me.message = '';
        }, time);
    } 
}

export default new MessageStore();